import { headers, parseJSON } from '../../apiUtils';
import { arrayIsNotEmpty, downloadFile, getUtcTime } from '../../utils';

export function fetchProgressOverTimeStatsByTeam(timePeriodicity, fromDate, toDate, reasonForContactId, channelTypeId, agentId) {
    //const toDateUtc = getUtcTime(toDate);
    //const fromDateUtc = getUtcTime(fromDate);
    let path = `/api/SurveyActivity/progress-over-time-stats-by-team?selectedTimePeriodicity=${timePeriodicity}&fromDate=${fromDate}&toDate=${toDate}`;
    if (reasonForContactId) {
        path += `&reasonForContactId=${reasonForContactId}`;
    }
    if (channelTypeId) {
        path += `&channelTypeId=${channelTypeId}`;
    }
    if (agentId) {
        path += `&agentId=${agentId}`;
    }

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchRfcBreakdown(fromDate, toDate, selectedFilters) {
    //const toDateUtc = getUtcTime(toDate);
    //const fromDateUtc = getUtcTime(fromDate);
    let path = `/api/SurveyActivity/rfc-breakdown?fromDate=${fromDate}&toDate=${toDate}`;
    if (arrayIsNotEmpty(selectedFilters)) {
        const newArray = selectedFilters.map(obj => {
            return {
                domainValueId: obj.id,
                domainValueName: obj.value,
                domainId: obj.domainId
            };
        });
        const stringifySelectedFilters = JSON.stringify(newArray);
        path += `&selectedFilters=${stringifySelectedFilters}`;
    }

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchChannelBreakdown(fromDate, toDate, selectedFilters, agentId) {
    //const toDateUtc = getUtcTime(toDate);
    //const fromDateUtc = getUtcTime(fromDate);
    let path = `/api/SurveyActivity/channel-breakdown?fromDate=${fromDate}&toDate=${toDate}`;
    if (arrayIsNotEmpty(selectedFilters)) {
        const newArray = selectedFilters.map(obj => {
            return {
                domainValueId: obj.id,
                domainValueName: obj.value,
                domainId: obj.domainId
            };
        });
        const stringifySelectedFilters = JSON.stringify(newArray);
        path += `&selectedFilters=${stringifySelectedFilters}`;
    }
    if (agentId) {
        path += `&agentId=${agentId}`;
    }

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchResponseBreakdown(surveyTypeId, fromDate, toDate, selectedFilters, agentId) {
    //const toDateUtc = getUtcTime(toDate);
    //const fromDateUtc = getUtcTime(fromDate);
    let path = `/api/SurveyActivity/response-breakdown?surveyTypeId=${surveyTypeId}&fromDate=${fromDate}&toDate=${toDate}`;
    if (arrayIsNotEmpty(selectedFilters)) {
        const newArray = selectedFilters.map(obj => {
            return {
                domainValueId: obj.id,
                domainValueName: obj.value,
                domainId: obj.domainId
            };
        });
        const stringifySelectedFilters = JSON.stringify(newArray);
        path += `&selectedFilters=${stringifySelectedFilters}`;
    }
    //if (agentId) {
    //    path += `&agentId=${agentId}`;
    //}

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchInteractionsReport(fromDate, toDate) {
    //const toDateUtc = getUtcTime(toDate);
    //const fromDateUtc = getUtcTime(fromDate);
    let path = `/api/SurveyActivity/report-interactions?fromDate=${fromDate}&toDate=${toDate}`;

    return downloadFile(path);

    //return fetch(path, {
    //    headers: headers(),
    //    method: 'GET'
    //}).then(parseJSON);
}

export function fetchCustomerInteractionsReport(fromDate, toDate) {
    //const toDateUtc = getUtcTime(toDate);
    //const fromDateUtc = getUtcTime(fromDate);
    let path = `/api/SurveyActivity/report-customer-interactions?fromDate=${fromDate}&toDate=${toDate}`;

    return downloadFile(path);

    //return fetch(path, {
    //    headers: headers(),
    //    method: 'GET'
    //}).then(parseJSON);
}

export function fetchCustomerInteractionsReportBySurveyDate(fromDate, toDate) {
    //const toDateUtc = getUtcTime(toDate);
    //const fromDateUtc = getUtcTime(fromDate);
    let path = `/api/SurveyActivity/report-customer-interactions-by-survey-date?fromDate=${fromDate}&toDate=${toDate}`;

    return downloadFile(path);
}

export function fetchAllInteractions(fromDate, toDate) {
    //const toDateUtc = getUtcTime(toDate);
    //const fromDateUtc = getUtcTime(fromDate);
    const path = `/api/SurveyActivity/all-interactions?fromDate=${fromDate}&toDate=${toDate}`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchUsersStats() {
    //const toDateUtc = getUtcTime(toDate);
    //const fromDateUtc = getUtcTime(fromDate);
    const path = `/api/SurveyActivity/users`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}